import React, {useEffect, useState} from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useAlert } from 'react-alert';
import TextField from '../../components/Form/TextField';
import { adminSignup } from '../../actions/authActions';
import { useDispatch} from 'react-redux';
import { Prod01 } from '../../constants/ActionType';

const ROLE_OPTIONS = {
    adminStaff: 'Org Manager (organization administrator)',
    admin: 'Super Admin (full platform access)',
    enrollment: 'Enrollment Coordinator (patient basics + devices)',
};

const AddNewAdminForm = ({ onHandleClose, onCreated, roles = ['adminStaff', 'admin', 'enrollment'] }) => {

    const dispatch = useDispatch();
    const alert = useAlert();

    const [showPassword, setShowPassword] = useState(false);
    const [orgs, setOrgs] = useState([]);

    useEffect(() => {
        if (!roles.includes('enrollment')) return;
        axios.get(`${Prod01}/general/organizations`).then(({ data }) => setOrgs(data || [])).catch(() => setOrgs([]));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const validate = Yup.object().shape({
        name: Yup.string().required('Name is Required'),
		email: Yup.string().email('Invalid email').required('Email is Required'),
		password: Yup.string() 
		  .min(6, 'Too Short!')
		  .max(20, 'Too Long!')
		  .required('Password is Required'),
	  });

    const submitHandler = async (values) => {
        if (values.role === 'enrollment') {
            const organizationIds = values.organizationIds.length || orgs.length !== 1 ? values.organizationIds : [String(orgs[0]._id)];
            if (!organizationIds.length) {
                alert.error('Select at least one organization');
                return;
            }
            try {
                await axios.post(`${Prod01}/enrollment/coordinators`, {
                    name: values.name,
                    email: values.email,
                    password: values.password,
                    organizationIds,
                });
                alert.success('Enrollment Coordinator created');
            } catch (err) {
                alert.error(err?.response?.data?.message || err.message);
                return;
            }
        } else {
            const { organizationIds, ...rest } = values;
            await dispatch(adminSignup(rest));
        }
        onHandleClose(false);
        if (onCreated) onCreated();
    }

  return (
    <div>
        <Formik initialValues={{
            name: '',
            email: '',
            password: '', 
            role: roles[0],
            organizationIds: [],
        }}
        validationSchema={validate}
        onSubmit={values => {
            submitHandler(values)
        }}
        >
        { formik => (
            <div>
                <Form>
                    <TextField 
                        label="Name" 
                        name="name"  
                        placeholder="Enter Name"
                    />

                    <TextField 
                        label="Email" 
                        name="email" 
                        type="email"	
                        placeholder="Enter Email"
                    />

                    <TextField 
                        label="Password" 
                        name="password" 
                        type={showPassword ? 'text' : 'password'}	
                        placeholder="Enter Password"
                    />             


                    <label htmlFor="role" className="form-label mt-3">Role</label>
                    <select
                        name="role"
                        className="form-control"
                        value={formik.values.role}
                        onChange={e => formik.setFieldValue('role', e.target.value)}
                    >
                        {roles.map((r) => <option key={r} value={r}>{ROLE_OPTIONS[r]}</option>)}
                    </select>
                    {formik.values.role === 'enrollment' && (
                        <div className="mt-3">
                            <label className="form-label">Organizations <span style={{ color: 'red' }}>*</span></label>
                            {orgs.map((o) => {
                                const id = String(o._id);
                                const checked = formik.values.organizationIds.includes(id) || (orgs.length === 1 && !formik.values.organizationIds.length);
                                return (
                                    <div key={id}>
                                        <input
                                            type="checkbox"
                                            id={`org-${id}`}
                                            checked={checked}
                                            onChange={() => formik.setFieldValue('organizationIds', checked
                                                ? formik.values.organizationIds.filter((x) => x !== id)
                                                : [...formik.values.organizationIds, id])}
                                        />
                                        &nbsp;<label htmlFor={`org-${id}`}>{o.name}</label>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    <div className="custom-control custom-checkbox">
                        <input 
                            type="checkbox" 
                            className="custom-control-input" 
                            id="defaultUnchecked"
                            onClick={() => setShowPassword(!showPassword)} 
                            />
                        <label className="custom-control-label" for="defaultUnchecked">Show Password</label>
                    </div>       
                    <br/><hr/>
                    <button className="reset-btn" type="submit">Save</button>
                </Form>
            </div>
            )}
        </Formik>
    </div>
  )
}

export default AddNewAdminForm
